import { ProductBuilderMachineContext } from '../types';
import { productPropertySummary } from './productPropertySummary';

type ShutterLineItems = (
  context: ProductBuilderMachineContext,
) => {
  _PRODUCTTYPE: string;
  _BFRAME: string;
  _COLORCODE: string;
  _FRAMETYPE: string;
  _HINGECOLOR: string;
  _HINGETYPE: string;
  _LFRAME: string;
  _LOUVERTYPE: string;
  _MOUNTTYPE: string;
  _MATCHITEM: string;
  _MIDRAILPOS1: string;
  _MIDRAILTYPE: string;
  _PGMCODE: string;
  _PANELCONFIG: string;
  _PANELQTY: string;
  _PANELTYPE: string;
  _REMARK: string;
  _RFRAME: string;
  _ROOM: string;
  _SIZETYPE: string;
  _SHUTTERTYPE: string;
  _STILETYPE: string;
  _TBGPOS1: string;
  _TBGPOS2: string;
  _TFRAME: string;
  _TPOSTQTY: string;
  _TPOSTCODE: string;
  _TILTRODPOS: string;
  _TPOSTSTANDARD: string;
  _dynamic_product: boolean;
};

export const getShutterLineItems: ShutterLineItems = context => {
  const { custom } = context;
  const productSummaryCapture = productPropertySummary(context);
  const currentVariant = context.productWithMeasurements
    ? context.productWithMeasurements.data.find(
        ({ attributes: { freight } }) => freight === context.custom.shipping,
      )
    : null;

  const baseProduct = context.products.filter(product =>
    product.variants.some(
      variant =>
        variant.id ===
        (currentVariant ? currentVariant.attributes.base_variant_id : null),
    ),
  );

  const colourCode = baseProduct
    ? baseProduct[0].tags
        .find(tag => tag.includes('Colour Code'))
        ?.replace('Colour Code: ', '')
    : '';
  let panelQty, hingeColor;

  hingeColor =
    custom.colour === 'Colour: Pearl'
      ? 'HC02'
      : custom.colour === 'Colour: Silk White'
      ? 'HC01'
      : 'HC15';

  panelQty =
    custom.panelConfiguration ===
      'Left Fold + Right, Post, Left Fold + Right' ||
    custom.panelConfiguration ===
      'Left Fold + Right, Post, Left + Right Fold' ||
    custom.panelConfiguration ===
      'Left + Right Fold, Post, Left + Right Fold' ||
    custom.panelConfiguration ===
      'Left, Post, Center Opening Fold, Post, Right' ||
    custom.panelConfiguration ===
      'Center Opening, Post, Center Opening, Post, Center Opening'
      ? '6'
      : custom.panelConfiguration ===
          'Left Fold + Right, Post, Center Opening' ||
        custom.panelConfiguration ===
          'Center Opening, Post, Left Opening + Right Fold' ||
        custom.panelConfiguration ===
          'Center Opening, Post, Center Opening, Post, Right' ||
        custom.panelConfiguration ===
          'Left Opening, Post, Center Opening, Post, Center Opening'
      ? '5'
      : custom.panelConfiguration === 'Center Opening Fold' ||
        custom.panelConfiguration === 'Center Opening, Post, Center Opening' ||
        custom.panelConfiguration ===
          'Left Opening, Post, Center Opening, Post, Right'
      ? '4'
      : custom.panelConfiguration === 'Left Fold + Right' ||
        custom.panelConfiguration === 'Left + Right Fold' ||
        custom.panelConfiguration === 'Left Fold, Post, Right' ||
        custom.panelConfiguration === 'Left, Post, Right Fold' ||
        custom.panelConfiguration === 'Center Opening, Post, Right' ||
        custom.panelConfiguration === 'Left, Post + Center Opening'
      ? '3'
      : custom.panelConfiguration === 'Left Opening' ||
        custom.panelConfiguration === 'Right Opening'
      ? '1'
      : '2';

  const panelConfig =
    custom.panelConfiguration ===
      'Center Opening, Post, Center Opening, Post, Center Opening' ||
    custom.panelConfiguration ===
      'Centre Opening, Post, Centre Opening, Post, Centre Opening'
      ? 'LRTLRTLR'
      : custom.panelConfiguration ===
          'Left, Post, Center Opening Fold, Post, Right' ||
        custom.panelConfiguration ===
          'Left, Post, Centre Opening Fold, Post, Right'
      ? 'LTLLRRTR'
      : custom.panelConfiguration ===
        'Left + Right Fold, Post, Left + Right Fold'
      ? 'LRRTLRR'
      : custom.panelConfiguration ===
        'Left Fold + Right, Post, Left + Right Fold'
      ? 'LLRTLRR'
      : custom.panelConfiguration ===
        'Left Fold + Right, Post, Left Fold + Right'
      ? 'LLRTLLR'
      : custom.panelConfiguration ===
          'Left Opening, Post, Centre Opening, Post, Centre Opening' ||
        custom.panelConfiguration ===
          'Left Opening, Post, Center Opening, Post, Center Opening'
      ? 'LTLRTLR'
      : custom.panelConfiguration ===
          'Centre Opening, Post, Centre Opening, Post, Right' ||
        custom.panelConfiguration ===
          'Center Opening, Post, Center Opening, Post, Right'
      ? 'LRTLRTR'
      : custom.panelConfiguration ===
          'Centre Opening, Post, Left Opening + Right Fold' ||
        custom.panelConfiguration ===
          'Center Opening, Post, Left Opening + Right Fold'
      ? 'LRTLRR'
      : custom.panelConfiguration ===
          'Left Fold + Right, Post, Centre Opening' ||
        custom.panelConfiguration === 'Left Fold + Right, Post, Center Opening'
      ? 'LLRTLR'
      : custom.panelConfiguration ===
          'Left Opening, Post, Centre Opening, Post, Right' ||
        custom.panelConfiguration ===
          'Left Opening, Post, Center Opening, Post, Right'
      ? 'LTLRTR'
      : custom.panelConfiguration === 'Centre Opening, Post, Centre Opening' ||
        custom.panelConfiguration === 'Center Opening, Post, Center Opening'
      ? 'LRTLR'
      : custom.panelConfiguration === 'Left, Post + Centre Opening' ||
        custom.panelConfiguration === 'Left, Post + Center Opening'
      ? 'LTLR'
      : custom.panelConfiguration === 'Centre Opening, Post, Right' ||
        custom.panelConfiguration === 'Center Opening, Post, Right'
      ? 'LRTR'
      : custom.panelConfiguration === 'Left, Post, Right Fold'
      ? 'LTRR'
      : custom.panelConfiguration === 'Left Fold, Post, Right'
      ? 'LLTR'
      : custom.panelConfiguration === 'Center Opening Fold' ||
        custom.panelConfiguration === 'Centre Opening Fold'
      ? 'LLRR'
      : custom.panelConfiguration === 'Left Fold + Right'
      ? 'LLR'
      : custom.panelConfiguration === 'Left + Right Fold'
      ? 'LRR'
      : custom.panelConfiguration === 'Left Fold'
      ? 'LL'
      : custom.panelConfiguration === 'Right Fold'
      ? 'RR'
      : custom.panelConfiguration === 'Left Opening'
      ? 'L'
      : custom.panelConfiguration === 'Right Opening'
      ? 'R'
      : custom.panelConfiguration === 'Centre Opening' ||
        custom.panelConfiguration === 'Center Opening'
      ? 'LR'
      : '';

  let tPostQty = String(panelConfig.match(/T/g)?.length);

  return {
    _PRODUCTTYPE: 'Shutter',
    _ROOM: context.custom.roomName,
    _MOUNTTYPE: context.custom.fitting === 'Reveal Fit' ? 'IN' : 'OUT',
    _BFRAME: '1', // Veneta only
    _COLORCODE: colourCode ? colourCode : '',
    _FRAMETYPE: context.custom.fitting === 'Reveal Fit' ? 'FZ02' : 'FL26',
    _HINGECOLOR: hingeColor, // pure HC15, Silkwhite HC01, Pearl HC02
    _HINGETYPE: '',
    _LFRAME: '1', // Veneta only
    _LOUVERTYPE: context.custom.bladeSize === '76mm' ? 'LE16' : 'LE04',
    _MATCHITEM: '', // empty
    _MIDRAILPOS1: '', // Veneta only
    _MIDRAILTYPE: '', // centre or none
    _PGMCODE: 'MDFP',
    _PANELCONFIG: panelConfig, // Based on config
    _PANELQTY: panelQty,
    _PANELTYPE: 'Regular',
    _REMARK: '', // empty
    _RFRAME: '1', // Veneta only
    _SIZETYPE:
      context.custom.fitting === 'Reveal Fit'
        ? 'Window Size'
        : 'Max Frame to Frame',
    _SHUTTERTYPE: 'full height',
    _STILETYPE: panelQty === '1' ? 'SB04' : 'SR03',
    _TBGPOS1: '', // Veneta only
    _TBGPOS2: '', // Veneta only
    _TFRAME: '1', // Veneta only
    _TPOSTQTY: tPostQty !== 'undefined' && tPostQty !== 'null' ? tPostQty : '', // Veneta only
    _TPOSTCODE: tPostQty !== 'undefined' && tPostQty !== 'null' ? 'TP21' : '', // Veneta only
    _TILTRODPOS:
      context.custom.operation === 'Control Bar'
        ? 'Control Bar'
        : 'Clear view Tilt',
    _TPOSTSTANDARD: tPostQty !== 'undefined' && tPostQty !== 'null' ? '1' : '', // empty
    _dynamic_product: true,
    ...productSummaryCapture,
  };
};
